import { Link } from "react-router-dom";
import { useTitle } from "../hooks";

export function NotFound() {
  useTitle("Nie znaleziono");
  return (
    <div className="state">
      <h1>Tej strony nie ma</h1>
      <p>Może to kolejny zapomniany hit. <Link to="/">Wróć na początek</Link> albo <Link to="/odkrywaj">poszukaj czegoś zapomnianego</Link>.</p>
    </div>
  );
}
